/* Section: Ship video — original: section#shipVideoSection.section.vid-band
   The "Ship video: silent desktop loop + Watch the full video" IIFE from the adensalt.com
   section scripts (js/section-scripts-b.js, live code as of 2026-09-30), unchanged. No endpoints,
   no globals. Keys off .vid-frame / video[data-loop][data-full][data-full-sm] / .vid-watch /
   .vid-loop-toggle emitted by parts/sections/ship_video.php. */
/* ---------- Ship video: silent desktop loop + "Watch the full video" ----------
   The loop only runs on a desktop with a fine pointer (1024px and up), without reduced motion or Save-Data. It loads when
   the section nears the viewport and pauses offscreen, while the tab is hidden, and from its own toggle (WCAG 2.2.2).
   Everyone else gets the poster; nothing loads until the button is pressed. The button swaps in the full cut (1080p on
   desktop, 720p under 1024px), unmuted, with native controls, from 0:00. */
(function(){
  var frame = document.querySelector('.vid-frame');
  if(!frame) return;
  var v = frame.querySelector('video'), watch = frame.querySelector('.vid-watch'), tog = frame.querySelector('.vid-loop-toggle');
  if(!v || !watch) return;
  var mm = function(q){ return !!(window.matchMedia && window.matchMedia(q).matches); };
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var canLoop = mm('(min-width:1024px) and (hover:hover) and (pointer:fine)') && !mm('(prefers-reduced-motion: reduce)') && !saveData;
  var mode = 'poster', near = false, userPaused = false;
  function syncLoop(){
    if(mode !== 'loop') return;
    if(near && !userPaused && !document.hidden){ var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }
    else if(!v.paused) v.pause();
  }
  function startLoop(){
    if(mode !== 'poster') return;
    mode = 'loop';
    v.muted = true; v.loop = true; v.controls = false;
    v.preload = 'auto'; v.src = v.getAttribute('data-loop');
    if(tog) tog.hidden = false;
    syncLoop();
  }
  if(tog) tog.addEventListener('click', function(){
    userPaused = !userPaused;
    tog.classList.toggle('is-paused', userPaused);
    tog.setAttribute('aria-label', userPaused ? 'Play video' : 'Pause video');
    syncLoop();
  });
  watch.addEventListener('click', function(){
    mode = 'full';
    frame.classList.add('is-full');
    try{ v.pause(); }catch(err){}
    v.loop = false;
    v.src = v.getAttribute(window.innerWidth >= 1024 ? 'data-full' : 'data-full-sm');
    v.muted = false; v.controls = true;
    try{ v.currentTime = 0; }catch(err){}
    var pr = v.play(); if(pr && pr.catch) pr.catch(function(){});
    try{ v.focus({preventScroll:true}); }catch(err){}
  });
  document.addEventListener('visibilitychange', syncLoop);
  if(canLoop && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      near = entries[0].isIntersecting;
      if(near) startLoop();
      syncLoop();
    }, {rootMargin:'200px 0px'}).observe(frame);
  }
})();
